import { SEVERITY } from "helpers/utils.js";
import {
  GET_STOCK_LOCATIONS,
  GET_STOCK_LOCATIONS_SUCCESS,
  GET_STOCK_LOCATION_BY_ID_SUCCESS,
  GET_STOCK_LOCATIONS_ERROR,
  STOCK_LOCATION_CLEAR_ERROR,
  GET_STOCK_LOCATION_BY_ID,
  ADD_NEW_STOCK_LOCATION,
  UPDATE_STOCK_LOCATION,
  DELETE_STOCK_LOCATION,
} from "./actionTypes.js"
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  totalOnHand: 0,
  totalOutgoing: 0,
  loading: false,
  message: null,
};

const stockRequestItem = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case DELETE_STOCK_LOCATION:
    case UPDATE_STOCK_LOCATION:
    case GET_STOCK_LOCATIONS:
      return {
        ...state,
        loading: true,
        item: null,
      };
    case GET_STOCK_LOCATIONS_SUCCESS:
      const { itemCount, pageCount, totalOnHand, totalOutgoing, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        totalOnHand,
        totalOutgoing,
        items: data,
        item: null,
        loading: false,
      };
    case ADD_NEW_STOCK_LOCATION:
      return {
        ...state,
        item: null,
      };
    case GET_STOCK_LOCATION_BY_ID:
      return {
        ...state,
        item: null,
      };
    case GET_STOCK_LOCATION_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_STOCK_LOCATIONS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_ItemUnitOfMeasurement");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Unit of Measurement already exist." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case STOCK_LOCATION_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default stockRequestItem;
